import { Button } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageLayout } from '@hero/components/layouts';
import { useIsAdminOrganization, useSelectedOrganization } from '@hero/hooks';
import { UserProfileForm, CompanyProfileForm, SettingsTabs } from '@hero/organisms';
import { logoutAndRedirect } from '@hero/utils';

import * as S from './style';

export default function AccountPage() {
  const { t } = useTranslation();
  const organization = useSelectedOrganization();
  const isOrganizationAdmin = useIsAdminOrganization();

  return (
    <PageLayout
      header={{
        title: t('settings')
      }}
    >
      <SettingsTabs />
      <S.Wrapper>
        <UserProfileForm organizationRole={organization?.role} />
        {isOrganizationAdmin && <CompanyProfileForm organization={organization} />}
        <Button onClick={logoutAndRedirect} variant="link" color="error">
          {t('logout')}
        </Button>
      </S.Wrapper>
    </PageLayout>
  );
}
